import React from 'react';
import {Router, Route, IndexRoute} from 'react-router';
import {history, store} from './redux/store';
import {HomeView, OldView, FoodView, OrderHistoryPage} from './modules';
import {FinanceView, ActView, DocsView} from './modules';
import App from './App';
import {LoginView, LogoutView} from "./modules";
import {LoadPartnerObjects, UserChange, LoadMenus, ChangeUser} from './modules/food/actions'
import {LoadFinances, LoadSaleDirections} from "./modules/finance/actions/index";
import {LoadDocs} from "./modules/documents/actions/index";

function requireAuth(nextState, replace) {
    if (!store.getState().auth.isAuthenticated) {
        replace({
            pathname: '/login',
            state: {nextPathname: nextState.location.pathname}
        })
    }
}

function loadPartnerObjects() {
    if (store.getState().food.objects.length > 0) {
        return Promise.resolve();
    }
    const promise = new Promise((ok) => {
    store.dispatch(LoadPartnerObjects()).then(() => {
        const {objects} = store.getState().food;
        const current = objects[0];
        store.dispatch(ChangeUser(current.id, current.type, current.fio));
        store.dispatch(UserChange(current.id, current.fio, current.type)).then(() => ok());
    })
    });
    return promise;
}

function loadPartnerObjectsAndMenu() {
    loadPartnerObjects().then(() =>
    {
        const {currentUser, date} = store.getState().food;
        store.dispatch(LoadMenus(date, currentUser));
    });
}

function loadPoAndFinance() {
    loadPartnerObjects().then(() =>
    {
        const {currentUser} = store.getState().food;
        store.dispatch(LoadFinances(currentUser.id, currentUser.type));
    });
}

function loadPoAndDocs() {
    loadPartnerObjects().then(() =>
    {
        const {currentUser} = store.getState().food;
        store.dispatch(LoadDocs(currentUser.id, currentUser.type));
    });
}

function loadPoAndSD() {
    loadPartnerObjects();
    store.dispatch(LoadSaleDirections());
}

export default () => (
    <Router history={history}>
        <Route path="/login" component={LoginView}/>
        <Route path="/logout" component={LogoutView}/>
        <Route path="/" component={App} onEnter={requireAuth}>
            <IndexRoute component={HomeView} onEnter={loadPartnerObjects} />
            <Route path="/food" component={FoodView} onEnter={loadPartnerObjectsAndMenu}/>
            <Route path="/history" component={OrderHistoryPage} onEnter={loadPartnerObjects}/>
            <Route path="/finance" component={FinanceView} onEnter={loadPoAndFinance}/>
            <Route path="/docs" component={DocsView} onEnter={loadPoAndDocs}/>
            <Route path="/act" component={ActView} onEnter={loadPoAndSD}/>
        </Route>
    </Router>
);



/** WEBPACK FOOTER **
 ** ./src/Routes.js
 **/